import { InteractionStatus } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Box, Button, SxProps, Theme, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Redirect, useHistory } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { useTitle } from 'shared/hooks';
import { AuthInProgress } from 'shared/providers';

const rootStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  padding: 15,
  height: 200,
};

export function Login() {
  useTitle('Multi-Brand CPQ Workflow Login');
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const { instance, inProgress } = useMsal();

  const login = async () => {
    try {
      await instance.loginRedirect();
      history.push(ROUTES.brands);
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };
  if (
    inProgress !== InteractionStatus.Startup &&
    (inProgress === InteractionStatus.Login || inProgress === InteractionStatus.HandleRedirect)
  ) {
    // TODO better auth in progress ui
    return (
      <Box sx={rootStyles}>
        <AuthInProgress />
      </Box>
    );
  }

  return (
    <>
      <AuthenticatedTemplate>
        <Redirect to={ROUTES.brands} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Box sx={rootStyles}>
          <Typography variant='h3'>Multi-Brand CPQ Workflow</Typography>
          <Button size='large' variant='contained' color='primary' onClick={login}>
            Login
          </Button>
        </Box>
      </UnauthenticatedTemplate>
    </>
  );
}
